// extracted by css-extract-rspack-plugin
export default {"upsellRibbon":"upsell-ribbon-module__upsellRibbon___Q6n33","overlayText":"upsell-ribbon-module__overlayText___vRA_d","button":"upsell-ribbon-module__button___MXSzM"};